export default __webpack_public_path__ + "static/color-picker-backgrounds-light-31c83dc5e1af6c46b0928eb2faff33b3.png";